import { getHomeHref as getHref } from '@/common/SearchBar/utils';
import TrackWrapper from '@/common/TrackWrapper';
import formatEvent from '@/home/utils/formatEvent';
import affordableCars from '~/constants/home/affordableCarCategories';
import CaretRight from '~/icons/CaretRight';
import Delivery from '~/icons/DeliveryMedium';
import EVPlugSavings from '~/icons/EVPlugSavings';
import GasSavings from '~/icons/GasSavings';
import GreatDeals from '~/icons/GreatDeals';
import PriceDrop from '~/icons/PriceDrop';
import { nativeSrpPayload } from '~/native/home/utils';
import {
  InnerWrapper,
  SectionTitle,
  GridWrapper,
  FeatureCard,
  FeatureIcon,
  FeatureLabel
} from './AffordableCars.styles';

const renderIcons = (iconName: string) => {
  switch (iconName) {
    case 'PriceDrop':
      return <PriceDrop className="h-32 w-32 sm:h-auto sm:w-auto" />;
    case 'GreatDeals':
      return <GreatDeals className="h-32 w-32 sm:h-auto sm:w-auto" />;
    case 'Delivery':
      return (
        <Delivery
          data-qa="delivery-by"
          className="h-32 w-32 sm:h-auto sm:w-auto"
        />
      );
    case 'GasSavings':
      return <GasSavings className="h-32 w-32 sm:h-auto sm:w-auto" />;
    case 'EVPlugSavings':
      return <EVPlugSavings className="h-32 w-32 sm:h-auto sm:w-auto" />;
  }
};

export default function AffordableCars() {
  const customAttributes = {
    description: 'Affordable Cars',
    isCarousel: false,
    content: affordableCars.map(feature => feature.copy)
  };

  const viewEvent = formatEvent('Viewed - Home feed section', customAttributes);

  return (
    <TrackWrapper event={viewEvent}>
      <InnerWrapper>
        <SectionTitle>Affordable cars available now</SectionTitle>
        <GridWrapper>
          {affordableCars.map(({ copy, iconName, id, link }) => {
            return (
              <a
                key={id}
                href={getHref(link)}
                data-analytics-id="Home feed card"
                data-analytics-attributes={JSON.stringify({
                  description: 'Affordable cars tile',
                  content: copy
                })}
                data-native-payload={nativeSrpPayload}
              >
                <FeatureCard>
                  <FeatureIcon>{renderIcons(iconName)}</FeatureIcon>
                  <FeatureLabel>{copy}</FeatureLabel>
                  <div className="align-center flex w-24 sm:hidden">
                    <CaretRight className="h-20 w-20 text-blue-6" />
                  </div>
                </FeatureCard>
              </a>
            );
          })}
        </GridWrapper>
      </InnerWrapper>
    </TrackWrapper>
  );
}
